import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowUp } from "react-icons/fi";
import Logo from "../../assets/images/danphe-logo.png";
import { useAppContext } from "../../context/store";
const Footer = () => {
  const { data } = useAppContext();
  const [showButton, setShowButton] = useState();
  const newDate = new Date().getFullYear();
  const serviceLink =
    data?.filter((item) => item?.name === "services")[0]?.serviceItems || [];
  const comapnyLink =
    data?.filter((item) => item?.name === "footer")[0]?.companyMenus || [];
  const socialLink =
    data?.filter((item) => item?.name === "socialIcons")[0]?.socialIcons || [];
  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  useEffect(() => {
    const scrollButton = () => {
      window.pageYOffset > 200 ? setShowButton(true) : setShowButton(false);
    };
    window.addEventListener("scroll", scrollButton);
    return () => {
      window.removeEventListener("scroll", scrollButton);
    };
  }, []);
  return (
    <footer className="site-footer ">
      <div className="container">
        <div className="site-footer_wrap">
          <div className="address">
            <div className="fw-600 is-uppercase fs-md mb-4 mt-40">9Feathers</div>
            <div className="address-content mt-16">
              <p>8th The Green #12974,</p>
              <p className="mb-4">
                Dover, DE 19901
              </p>
              <p className="mb-4">+19253990077</p>
              <Link to="mailto:info@9feathers.app">info@9feathers.app</Link>
            </div>
          </div>
          <div className="services-col ">
            <div className="fw-600 is-uppercase fs-md mb-4 mt-40">Services</div>
            <ul className="link-list">
              {serviceLink.map((item, index) => {
                return (
                  <li key={index} id={item.id}>
                    <Link to="/">{item.title}</Link>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="company-col">
            <div className="fw-600 is-uppercase fs-md mb-4 mt-40">Company</div>
            <ul className="link-list">
              {comapnyLink.map((item, index) => {
                return (
                  <li key={index} id={item.id}>
                    <Link to={item.to}>{item.name}</Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className="fs-md pt-16 mt-40" style={{ textAlign: "center", opacity: 0.85, marginBottom: "16px" }}>
          <p>
            All services are provided under signed agreements. No products are sold and no automated payments are processed through this website.
          </p>
          <p className="mt-4">
            <Link to="/terms" className="clr-primary">Terms</Link>
            {" | "}
            <Link to="/privacy-policy" className="clr-primary">Privacy Policy</Link>
            {" | "}
            <Link to="/refund-policy" className="clr-primary">Refund Policy</Link>
          </p>
        </div>
        <div className="copyright is-flex is-between is-align-center fs-md pt-16">
          <p>
            © 9Feathers <span>{newDate}</span>. All Rights Reserved.
          </p>
          <div className="is-flex is-end is-align-center col-gap-12">
            {socialLink.map((item, index) => {
              return (
                <Link
                  key={index}
                  id={item.id}
                  to={item.url}
                  target="_blank"
                  className="is-square is-square_circle is-square_icon is-square_xs"
                >
                  {item.icon}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
      {showButton && (
        <button
          className="is-square is-square_circle is-square_sm scroll-top"
          onClick={() => handleScrollTop()}
        >
          <FiArrowUp />
        </button>
      )}
    </footer>
  );
};

export default Footer;
